// Vue
import { Component, Prop, Vue } from "vue-property-decorator";
// Template
import template from "./template.vue";

@Component({
  mixins: [template],
  components: {},
})
export class ModelSelectionModuleButton extends Vue {
  @Prop()
  public icon!: string;

  @Prop({ type: [String], default: "mgs" })
  public file?: string;

  @Prop()
  public theme!: string;

  public onButtonClick(event) {
    this.$emit("click", event);
  }
}
